import { fetcher, IFetchPostResponse } from "./api";

export async function put<T>(
  url: string,
  data
): Promise<IFetchPostResponse<T>> {
  return await fetcher<any>({
    url: url,
    method: "PUT",
    body: data,
  });
}
